import React, { useEffect, useMemo, useState } from "react";
import './profile.scss'
import { useLocation } from "react-router-dom";
import VerticalTab from "../../components/common/tabs/vertical/vertical-tab";
import ProfileName from "../../components/common/Profile/profile-name";
import { useDispatch, useSelector } from "react-redux";
import UserInfo from "../../components/profile-info/user-info";
import EducationalInfo from "../../components/profile-info/educational-info";
import ResetPassword from "../../components/profile-info/reset-password";
import { post, put, get } from "../../utils/fetchAPI";
import { removeAuthInfo, setAuthInfo, setSelectedRole, setUserRoles } from "../../store/slices/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOut } from "@fortawesome/free-solid-svg-icons";
import { Toast } from "../../utils/SwalUti";
import PrescriptionSettingsTab from "./PrescriptionSettingsTab";
import VisitSectionsSettingsTab from "./VisitSectionsSettingsTab";
import GroupsSettingsTab from "./GroupsSettingsTab";
import { snapshotFromUploadApiFile } from "../../components/profile-info/detailsFiles";
import { ReferraListCreate } from "../../components/settings/referral/referraListCreate";
import { ResearchTagCreate } from "../../components/settings/resarch-tags/researchTags";
import ChambersSettings from "../../components/settings/chambers/chambers-settings";


const Profile = () => {

  const [selectedOption, setSelectedOption] = useState({
    id: 1,
    name: "Vital signs",
  });
  const [selectedSubOption, setSelectedSubOption] = useState({
    parentId: "",
    subId: "",
  });
  const { user, userRoles, selectedRole } = useSelector((state) => state.auth);
  const [info, setInfo] = useState();
  const [prescriptionInfo, setPrescriptionInfo] = useState({});
  const [updatedInfo, setUpdatedInfo] = useState({});
  const [passInfo, setPassInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false)
  const [prescriptionSettingUpdatedInfo, setPrescriptionSettingUpdatedInfo] = useState({})
  const [prescriptionSettingShowInfo, setPrescriptionSettingShowInfo] = useState()
  let formBody = new FormData();



  const options = info?.user?.type == "staff" ? [
    {
      id: 1,
      name: 'My Profile'
    }
  ] : [{
    id: 1,
    name: 'My Profile'
  },
  {
    id: 3,
    name: 'Prescription'
  },
  {
    id: 4,
    name: 'Referral & research tags'
  },
  {
    id: 5,
    name: 'Chambers'
  },
  {
    id: 6,
    name: 'Visit sections'
  },
  {
    id: 7,
    name: 'Groups'
  }]
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    if (user?.user?._id) {
      userDetais(user?.user?._id)
    }
  }, [user])

  const setInfoFun = (key, value, other) => {
    let userInfo = { ...info };
    if (other == "details") {
      setInfo({ ...userInfo, details: { ...userInfo['details'], [key]: value } });
      let detailsKey = 'details.' + key
      setUpdatedInfo({ ...updatedInfo, [detailsKey]: value })
    }
    else {
      setInfo({ ...userInfo, [key]: value });
      setUpdatedInfo({ ...updatedInfo, [key]: value });
    }
  };

  /**
   * @param field nidFront | nidBack | signature | profilePicture | backgroundImage
   * @param fileDocOrId API `file` document from upload response, or legacy string id
   */
  const setDetailsFileField = (field, fileDocOrId) => {
    const snap =
      typeof fileDocOrId === "string"
        ? { file: fileDocOrId, bucketName: "", key: "", visibility: "" }
        : snapshotFromUploadApiFile(fileDocOrId);

    setInfo((prev) => {
      if (!prev) return prev;
      const prevSlot = prev.details?.files?.[field];
      const mergedSlot =
        typeof prevSlot === "object" && prevSlot != null && !Array.isArray(prevSlot)
          ? { ...prevSlot, ...snap }
          : snap;
      return {
        ...prev,
        details: {
          ...prev.details,
          files: {
            ...(prev.details?.files || {}),
            [field]: mergedSlot,
          },
        },
      };
    });
    setUpdatedInfo((prev) => {
      const next = { ...prev };
      delete next[`details.files.${field}`];
      next[`details.files.${field}.file`] = snap.file != null ? String(snap.file) : "";
      next[`details.files.${field}.bucketName`] = snap.bucketName ?? "";
      next[`details.files.${field}.key`] = snap.key ?? "";
      next[`details.files.${field}.visibility`] = snap.visibility ?? "";
      return next;
    });
  };

  const setPassInfoFun = (key, value, other) => {
    let temp = { ...passInfo };
    setPassInfo({ ...temp, [key]: value });
  };

  const handleSubmit = async () => {
    let userInfo = JSON.parse(localStorage.getItem('user'))
    setIsLoading(true)

    for (var key in updatedInfo) {
      if (updatedInfo.hasOwnProperty(key)) {
        formBody.append(key, updatedInfo[key]);
      }
    }

    await post('user/update', formBody)
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false)
          dispatch(setAuthInfo({ token: userInfo?.token, user: res?.data }))
          Toast.fire({
            icon: '',
            title: "Data saved successfully"
          })
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false)
      });
  }
  // const handlePrescriptionSubmit = async () => {
  //   let userInfo = JSON.parse(localStorage.getItem('user'))
  //   setIsLoading(true)
  //   await post('user/update', prescriptionSettingUpdatedInfo)
  //     .then((res) => {
  //       if (res.status === 200) {
  //         setIsLoading(false)
  //         dispatch(setAuthInfo({ token: userInfo?.token, user: res?.data }))
  //         Toast.fire({
  //           icon: '',
  //           title: "Prescription data saved successfully"
  //         })
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false)
  //     });
  // }
  const handlePrescriptionSubmit = async () => {
    let userInfo = JSON.parse(localStorage.getItem('user'))
    setIsLoading(true)
    await put(`user/role/update/${selectedRole?._id}`, prescriptionSettingUpdatedInfo)
      .then((res) => {
        if (res.status === 200) {
          let data = { ...selectedRole, config: res?.data?.config || selectedRole?.config }
          let roles = [...userRoles]
          roles[getIndexById(data?._id)] = data
          setIsLoading(false)
          dispatch(setSelectedRole(data))
          dispatch(setUserRoles(roles))
          // Drop the accumulated dotted-key deltas so a stale value (e.g. a default
          // customizeHeader) can't be re-sent and clobber the config on the next save.
          setPrescriptionSettingUpdatedInfo({})
          Toast.fire({
            icon: '',
            title: "Prescription data saved successfully"
          })
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false)
      });
  }

  function getIndexById(id) {
    return userRoles.findIndex(item => item._id === id);
  }
  const handleResetFun = async () => {
    setIsLoading(true)
    await post('user/update', passInfo)
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false)
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false)
      })
      .finally(() => {
        setIsLoading(false)
      });

  }


  const userDetais = async (id) => {
    // setIsLoading(true)
    await get(`user/details/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setInfo(res?.data)
        }
      })
      .catch((error) => {
        console.log(error);
        // setIsLoading(false)
      })
      .finally(() => {
        // setIsLoading(false)
      });

  }
  const handleLogout = () => {
    dispatch(removeAuthInfo())
    localStorage.clear();
  };
  const prescriptionSettingSetInfoFun = (key, value) => {
    // Functional updaters: multiple set() calls in the same batch must compose, not
    // clobber. A non-functional spread captures a stale snapshot, so the last write in a
    // batch wins and earlier keys (e.g. config.customizeHeader) get silently dropped.
    setPrescriptionSettingUpdatedInfo((prev) => ({ ...prev, [`config.${key}`]: value }))
    setPrescriptionSettingShowInfo((prev) => ({ ...(prev || {}), [key]: value }))
  }

  useMemo(() => {
    if (selectedRole?._id) {
      setPrescriptionSettingShowInfo(selectedRole?.config)
      setPrescriptionInfo({ prescriptionFooter: selectedRole?.config?.prescriptionFooter || "", prescriptionHeader: selectedRole?.config.prescriptionHeader || "" })
      // Switching role/location is a clean slate: drop the previous role's unsaved deltas so
      // they can't leak into the newly-selected role's config on the next save.
      setPrescriptionSettingUpdatedInfo({})
    }
  }, [selectedRole])


  return <section className="profile-page" style={{ marginLeft: "71px" }}>
    <div className="menu">
      <div className="p-1 d-flex pt-2">
        <ProfileName></ProfileName>
        <p className="mx-2 mt-1" style={{ fontSize: '14px', fontWeight: "600" }}>{user?.user?.name}</p>
        <button
          type="submit"
          className="btn save-button submit-button-position mt-1 ml-auto  w-25"
          onClick={() => { handleLogout() }}
        >
          <FontAwesomeIcon
            className="px-1"
            size="1x"
            icon={faSignOut}
          />
        </button>
      </div>
      <VerticalTab
        backUrl={`/waiting-room${location?.search}`}
        setSelectedSubOption={setSelectedSubOption}
        setSelectedOption={setSelectedOption}
        selectedOption={selectedOption}
        selectedSubOption={selectedSubOption}
        options={options}
        tabTitle={"Option"}
        sectionHeaderTitle="Setting"
      ></VerticalTab>
    </div>
    <div className="main-content pt-4">

      {selectedOption?.id == 1 && <div className="my-profile-layout">
        <div className="row no-gutters my-profile-grid">
          <div className="col-md-6 profile-column profile-column--left mb-2 mb-md-0 d-flex flex-column">
            <UserInfo isSubmitting={isLoading} handleSubmit={handleSubmit} info={info} setInfoFun={setInfoFun} setDetailsFileField={setDetailsFileField}></UserInfo>
            <div className="profile-reset-below-basic mt-2">
              <ResetPassword
                isSubmitting={isLoading}
                handleSubmit={handleResetFun}
                info={passInfo}
                setInfoFun={setPassInfoFun}
              />
            </div>
          </div>
          <div className="col-md-6 profile-column profile-column--right">
            <EducationalInfo isSubmitting={isLoading} setDetailsFileField={setDetailsFileField} handleSubmit={handleSubmit} info={info} setInfoFun={setInfoFun}></EducationalInfo>
          </div>
        </div>
      </div>}

      {selectedOption?.id == 4 && (
        <div className="my-profile-layout referral-research-settings-page">
          <header className="referral-research-settings-page__header">
            <h2 className="referral-research-settings-page__title">Referral & research tags</h2>
            <p className="referral-research-settings-page__subtitle">
              Manage saved referral lines and research tags for visits, appointments, and the research view.
            </p>
          </header>
          <div className="row no-gutters referral-research-settings-page__grid">
            <div className="col-lg-6 referral-research-settings-page__col mb-3 mb-lg-0">
              <ReferraListCreate />
            </div>
            <div className="col-lg-6 referral-research-settings-page__col">
              <ResearchTagCreate />
            </div>
          </div>
        </div>
      )}
      

      {selectedOption?.id == 3 && (
        <PrescriptionSettingsTab
          prescriptionSettingShowInfo={prescriptionSettingShowInfo}
          prescriptionSettingSetInfoFun={prescriptionSettingSetInfoFun}
          handlePrescriptionSubmit={handlePrescriptionSubmit}
          isLoading={isLoading}
          prescriptionInfo={prescriptionInfo}
          setPrescriptionInfo={setPrescriptionInfo}
        />
      )}

      {selectedOption?.id == 5 && (
        <div className="my-profile-layout chambers-settings-page">
          <ChambersSettings />
        </div>
      )}

      {selectedOption?.id == 6 && (
        <VisitSectionsSettingsTab
          prescriptionSettingShowInfo={prescriptionSettingShowInfo}
          prescriptionSettingSetInfoFun={prescriptionSettingSetInfoFun}
          handlePrescriptionSubmit={handlePrescriptionSubmit}
          isLoading={isLoading}
        />
      )}

      {selectedOption?.id == 7 && <GroupsSettingsTab />}

    </div>
  </section >;
};

export default Profile;
